import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const ClienteBarChart = ({ data, isLoading }) => {
  const [filter, setFilter] = useState('Top 20');

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  // Utility function to truncate labels with "..."
  const truncateLabel = (label, maxLength = 20) => {
    if (label.length > maxLength) {
      return label.substring(0, maxLength) + '...';
    }
    return label;
  };

  const getChartData = () => {
    if (!data || data.length === 0) return { labels: [], datasets: [] };

    let sortedData = data.reduce((acc, item) => {
      acc[item.ClienteNombre] = (acc[item.ClienteNombre] || 0) + 1;
      return acc;
    }, {});

    sortedData = Object.entries(sortedData).sort((a, b) => b[1] - a[1]);

    if (filter === 'Top 20') {
      sortedData = sortedData.slice(0, 20);
    } else if (filter === 'Top 50') {
      sortedData = sortedData.slice(0, 50);
    }

    const labels = sortedData.map(item => truncateLabel(item[0]));
    const counts = sortedData.map(item => item[1]);

    return {
      labels,
      datasets: [{
        label: 'Number of Traficos',
        data: counts,
        backgroundColor: 'rgba(33, 37, 41, 0.6)',
      }]
    };
  };

  const options = {
    indexAxis: 'y',
    plugins: {
      legend: { display: false },
      datalabels: {
        anchor: 'end',
        align: 'right',
        backgroundColor: 'rgba(173, 216, 230, 0.85)',
        borderRadius: 4,
        color: '#000',
        font: { weight: 'bold' },
        formatter: (value) => value,
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full" style={{ maxHeight: '500px', overflowY: 'auto' }}>
      <div className="mb-4 flex justify-between items-center">
        <h2 className="text-lg font-bold text-gray-800">
          <FontAwesomeIcon icon={faChartBar} className="text-blue-600 mr-2" />
          Productivity per Customer
        </h2>
        <select onChange={handleFilterChange} className="border-gray-300 rounded-md">
          <option value="Top 20">Top 20</option>
          <option value="Top 50">Top 50</option>
          <option value="All">All</option>
        </select>
      </div>
      {isLoading ? (
        <div className="flex justify-center items-center h-full">
          <FontAwesomeIcon icon={faSpinner} className="animate-spin text-xl" />
          <span className="ml-2 text-lg">Loading...</span>
        </div>
      ) : (
        <Bar data={getChartData()} options={options} />
      )}
    </div>
  );
};

export default ClienteBarChart;
